import { isCreateExaminationModalOpenAtom } from "Order/Modules/Examination/Atom/createExaminationModalAtom";
import { CreateExaminationForm } from "Order/Modules/Examination/Components/Form/CreateExaminationForm";
import { Dialog, DialogContent, DialogTitle } from "@mui/material";
import { useAtom } from "jotai";
import type { FC } from "react";

type CreateExaminationModalProps = {
	orderId: number;
};

export const CreateExaminationModal: FC<CreateExaminationModalProps> = ({
	orderId,
}) => {
	const [isExaminationModalOpen, setIsExaminationModalOpen] = useAtom(
		isCreateExaminationModalOpenAtom,
	);
	return (
		<Dialog
			open={isExaminationModalOpen}
			onClose={() => setIsExaminationModalOpen(false)}
			maxWidth="sm"
			fullWidth
		>
			<DialogTitle>Create Examination</DialogTitle>
			<DialogContent>
				<CreateExaminationForm
					orderId={orderId}
					setIsExaminationModalOpen={setIsExaminationModalOpen}
				/>
			</DialogContent>
		</Dialog>
	);
};
